(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    "use strict";function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){function t(){var e=document.querySelectorAll(".qq-hero-slider .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var i;function n(){(i=document.getElementsByClassName("qq-hero-slider")).length&&function e(){{var t,i,n;null==("undefined"==typeof $?"undefined":_typeof($))||null==window.$?((t=document.createElement("script")).id="qq-jquery",document.head.appendChild(t),t.type="text/javascript",t.src="https://code.jquery.com/jquery-3.6.0.min.js",t.onload=function(){e()}):document.getElementById("qq-slick")&&document.getElementById("qq-slick-css")?i=setInterval(function(){$.fn.slick&&(clearInterval(i),o())},10):(document.getElementById("qq-slick")||((n=document.createElement("script")).id="qq-slick",document.head.appendChild(n),n.type="text/javascript",n.src="https://cdn.jsdelivr.net/npm/slick-slider@1.8.1/slick/slick.min.js",n.onload=function(){e()}),document.getElementById("qq-slick-css")||((n=document.createElement("link")).id="qq-slick-css",document.head.appendChild(n),n.type="text/css",n.rel="stylesheet",n.href="https://cdn.jsdelivr.net/npm/slick-slider@1.8.1/slick/slick.css"))}}()}function o(){for(var e=0;e<i.length;e++)!function(e){{var n,t,s,i,o,l,d,r,a,c,u,p,f,m,q,h,y,v,g;$("#"+e).length&&(n=function(){var e,t,i=p.parent();p.length&&(e=s.outerHeight(!0),t=(t="0"==(t=($(window).width()<799&&0<s.find(".slick-current img.qq-mobile").length?s.find(".slick-current img.qq-mobile"):s.find(".slick-current img")).outerHeight(!0))?e:t)/2-p.outerHeight(!0)/2,p.add(f).css("top",t),t=s.find(".qq-slide").length,i.hasClass("qq-hidden")&&1<t&&i.removeClass("qq-hidden"))},t=function(){var e,t,i,n,o;$(window).width()<799&&(t=(e=s.find("ul.slick-dots")).outerHeight(!0),i=Number(s.attr("data-dotsMobileTopMargin")),void 0!==(o=s.attr("data-sliderDotsPositionMobile"))?(console.log("sliderDotsPosition: ",o),o=void 0===(o=s.find(".qq-slide-wrapper"))||0===o.length?(n="bottom",i):(n="top",o.position().top-t-i),e.css(n,+o+"px")):e.css("bottom","-"+(t+i)+"px"))},$("#"+e),s=$("#"+e).find(".qq-slides"),i=Number(s.attr("data-sliderSlidesToShow")),o=Number(s.attr("data-sliderSlidesToShowMobile")),l=/true/i.test(s.attr("data-sliderAutoplay")),d=1e3*Number(s.attr("data-sliderSpeed")),r=Boolean(s.attr("data-sliderInfinite")),v=s.attr("data-sliderAnimation"),a=s.attr("data-sliderNavigation"),p=$("#"+e+" span.qq-slider-prev"),f=$("#"+e+" span.qq-slider-next"),c=s.attr("data-sectionCustomHeight"),s.find(".qq-slide-text"),self["sliderContent"+e]&&self["sliderContent"+e].slick("unslick"),$("#"+e+" .qq-slider-slider-items"),"dots"==a?u=!(m=!0):"none"==a?u=m=!1:(u=!0,p=$("#"+e+" span.qq-carousel-prev"),f=$("#"+e+" span.qq-carousel-next"),m="both"==a),q=!1,y=$("html").attr("dir"),h=$("html").css("direction"),(null!=y&&"rtl"==y||null!=_typeof(h)&&"rtl"==h)&&(q=!0,null==y&&$("html").attr("dir","rtl")),console.log("rtl: ",q),y=1==i&&"fade"==v?!0:!1,v=1==o&&"fade"==v,self["sliderContent"+e]=$("#"+e+" .qq-slides").not(".slick-initialized").on("init reInit setPosition",function(){clearInterval(g),g=setTimeout(function(){"both"==a?(t(),n()):"dots"==a?t():"arrows"==a&&n()},500)}).slick({loop:!0,slidesToShow:i,slidesToScroll:1,infinite:r,swipeToSlide:!0,adaptiveHeight:!!c,rtl:q,arrows:u,dots:m,fade:y,rows:0,prevArrow:p,nextArrow:f,autoplay:l,autoplaySpeed:l?d:void 0,centerMode:!1,focusOnSelect:!0,responsive:[{breakpoint:768,settings:{slidesToShow:o,fade:v}}]}),s.on("afterChange",function(e,t,i){n()}))}}("qq"+i[e].id.replace("template--","").replace("shopify-section-","").replace("__",""))}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()}),window.addEventListener("shopify:block:select",function(o){if(i.length)for(var e=0;e<i.length;e++)!function(e){var e=i[e].id,n="qq"+e.replace("template--","").replace("shopify-section-","").replace("__","");"shopify-section-"+o.detail.sectionId===e&&setTimeout(function(e){var t=$("#"+n+" .slick-slider"),i=$("#"+n+' .qq-slide[data-shopify-editor-block=\'{"id":"'+o.detail.blockId+'","type":"slide"}\']').attr("data-slick-index");t.slick("slickGoTo",Number(i),!0)},100,e)}(e)})}();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
			updateCurrencies();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
$( document ).ready(function() {
  $('.img-viewed').click(function(e){
    $('.recently-viewed-content').addClass('active');
    setTimeout(function(){ 
      $('.recently-viewed').addClass('show');
     }, 200);
  });
  $('.recently-viewed-banner, .close').click(function(e){
    $('.recently-viewed-content').removeClass('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
